import { create } from 'zustand';

export type Theme = 'light' | 'dark';

interface ThemeStore {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

export function applyTheme(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

/** Read persisted preference and apply class immediately (call before React renders). */
export function initTheme() {
  const stored = localStorage.getItem('tm-theme') as Theme | null;
  const theme: Theme = stored === 'light' || stored === 'dark' ? stored : 'dark';
  applyTheme(theme);
  return theme;
}

const initial = initTheme();

export const useThemeStore = create<ThemeStore>()((set) => ({
  theme: initial,
  setTheme: (theme) => {
    localStorage.setItem('tm-theme', theme);
    applyTheme(theme);
    set({ theme });
  },
}));
